export const showMessageOptions = "is0e6";
export default {showMessageOptions};